<template>
    <div>
        <limitless-page-header
            title="Ekonomi"
            :sub-title="(mode === 'redeemed' ? 'Inlösta kort - ' : (mode === 'notredeemed' ? 'Ej inlösta kort - ' : ''))
             + 'Kortserie: ' + cardSeriesId + ' - '
             + (isNaN(year) ? year : (year ? ' ' + (year) + '-09-01 - ' + (parseInt(year) + 1) + '-08-31' : ''))"
        >
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'economy.stats.cardseries', params: { year: year } }" icon="icon-circle-left2">Tillbaka</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <i v-if="loading" class="icon-spinner2 spinner"></i>
            <div v-else-if="report" class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-auto">
                            <div class="btn-group">
                                <button type="button" class="btn" :class="{ 'btn-light': mode !== 'redeemed', 'btn-primary': mode === 'redeemed' }"
                                        @click="$router.push({ name: 'economy.stats.cards', params: { cardSeriesId, year, mode: 'redeemed' }})">Inlöst</button>
                                <button type="button" class="btn" :class="{ 'btn-light': mode !== 'notredeemed', 'btn-primary': mode === 'notredeemed' }"
                                        @click="$router.push({ name: 'economy.stats.cards', params: { cardSeriesId, year, mode: 'notredeemed' }})">Ej inlöst</button>
                                <button type="button" class="btn" :class="{ 'btn-light': mode !== 'all', 'btn-primary': mode === 'all' }"
                                        @click="$router.push({ name: 'economy.stats.cards', params: { cardSeriesId, year, mode: 'all' }})">Alla</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive mb-0">
                    <table class="table table-xs">
                        <thead>
                            <tr>
                                <th>Kortnummer</th>
                                <th>Order</th>
                                <th>Inlöst</th>
                                <th class="text-right">Pris</th>
                                <th class="text-right">Kostnad</th>
<!--                                <th class="text-right">TB</th>-->
<!--                                <th class="text-right">TG</th>-->
                                <th class="text-right">Källa</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(row, r_index) in report.table"
                                :key="'row-' + r_index"
                            >
                                <td><router-link :to="{ name: 'prodorders.list', query: { search: row.CardUID } }">{{ row.CardUID }}</router-link></td>
                                <td><router-link :to="{ name: 'cardorder.edit', params: { id: row.OrderID } }">{{ row.OrderID }}</router-link></td>
                                <td>{{ row.is_redeemed ? 'Ja' : 'Nej' }}</td>
                                <td class="text-right">{{ formatNumber(row.card_price, 2) }} kr</td>
                                <td class="text-right">{{ formatNumber(row.card_cost, 2) }} kr</td>
<!--                                <td class="text-right">{{ formatNumber(row.card_price-row.card_cost, 2) }} kr</td>-->
<!--                                <td class="text-right">{{ formatNumber(((row.card_price-row.card_cost)/row.card_price)*100, 1) }} %</td>-->
                                <td class="text-right">{{ row.Source }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th>Serie: {{ this.cardSeriesId }}</th>
                                <th>Antal: {{ formatNumber(report.totals.num_cards, 0) }}</th>
                                <th v-if="mode === 'all'">Antal inlösta: {{ formatNumber(report.totals.num_redeemed, 0) }}</th>
                                <th v-else></th>
                                <th class="text-right"> {{ formatNumber(report.totals.card_price, 2) }} kr</th>
                                <th class="text-right"> {{ formatNumber(report.totals.card_cost, 2) }} kr</th>
<!--                                <td class="text-right">{{ formatNumber(report.totals.card_price-report.totals.card_cost, 2) }} kr</td>-->
<!--                                <td class="text-right">{{ formatNumber(((report.totals.card_price-report.totals.card_cost)/report.totals.card_price)*100, 1) }} %</td>-->
                                <th></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import apiClient from '@services/ApiClient';
import { formatNumber } from '@services/Helpers';

export default {
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    props: {
        cardSeriesId: {
            type: [Number, String],
            required: true,
        },
        year: {
            type: [Number, String],
            required: true,
        },
        mode: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        report: null,
    }),
    mounted() {
        this.init();
    },
    watch: {
        cardSeriesId() {
            this.init();
        },
        year() {
            this.init();
        },
        mode() {
            this.init();
        },
    },
    methods: {
        formatNumber,
        init() {
            this.getData();
        },
        getData() {
            this.loading = true;
            apiClient.get('/vue/economy/stats/cards?card_series_id=' + this.cardSeriesId + '&year=' + this.year + '&mode=' + this.mode)
                .then((response) => {
                    this.report = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};

</script>
